import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { renameProject, createProject } from '../../actions/project'
import NewProjectForm from './struct'

const mapStateToProps = state => ({
  currentValue: dotProp.get(state, 'project.name', ''),
})

const mapDispatchToProps = dispatch => ({
  onChange: e => dispatch(renameProject(e.target.value)),
  onSubmit: e => dispatch(createProject()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewProjectForm)



// WEBPACK FOOTER //
// ./src/containers/NewProjectForm/index.js